import styled, { createGlobalStyle } from 'styled-components';

import { InputSearch } from 'ui/inputs';
import { spacing } from 'ui/theme';

// hide the page footer on this view since we don't use it
export const NoFooter = createGlobalStyle`
    [data-test="footer"] {
      display: none !important;
    }
  `;

export const WideInputText = styled(InputSearch)`
  width: ${spacing.x16};
`;
